import React from 'react'
import { BaseRow } from './BaseRow'
import { PlaceholderAvatar } from './BaseRow.styles'
import { BoxProps } from '@sketch/components'

export interface BasePlaceholderRowProps extends BoxProps {
  name?: string
  showStripes?: boolean
}

export const BasePlaceholderRow = ({
  name = 'Placeholder item',
  showStripes = false,
  ...boxProps
}: BasePlaceholderRowProps) => (
  <BaseRow
    name={name}
    avatar={<PlaceholderAvatar size="32px" name="" flavour="color" />}
    showStripes={showStripes}
    {...boxProps}
  >
    <span className="sr-only">{name}</span>
  </BaseRow>
)
